import { apiFetch } from "@/shared/api/http";

export interface StudentHomeData {
  aluno: {
    alunoId: string;
    nome: string;
    fotoUrl?: string | null;
    modalidade?: string | null;
    turma?: string | null;
  };
  proximaAula?: {
    turmaId: string;
    turmaNome: string;
    modalidade: string;
    data: string;
    horaInicio: string;
    horaFim: string;
    quando: string;
  } | null;
  ultimoTreino?: {
    sessaoId: string; turmaId: string; horarioTurmaId: string; data: string; horaInicio: string; turmaNome: string; modalidade: string; professor?: string | null; tema?: string | null; resumo?: string | null; conteudos: string[]; momentos: Array<{momentoId:string;midiaId:string;url:string}>;
  } | null;
  proximaCompeticao?: {
    campeonatoId: string;
    nome: string;
    data: string;
    local?: string | null;
    modalidade: string;
    categoria: string;
    faixa?: string | null;
    categoriaPeso?: string | null;
    status: string;
    inscricaoExternaConfirmada: boolean;
    resultado?: string | null;
    colocacao?: number | null;
  } | null;
  frequencia: {
    totalRegistros: number;
    presentes: number;
    ausentes: number;
    justificados: number;
    percentual: number;
  };
  graduacao?: {
    faixa: string;
    grau: number;
    data?: string | null;
  } | null;
  pendencias: Array<{ codigo:string; titulo:string; detalhe?:string|null; area:string }>;
  financeiro: {
    situacao: string;
    saldoAberto: number;
    proximoVencimento?: string | null;
    titulosEmAberto: number;
    titulosVencidos: number;
  };
}

export function fetchStudentHome() {
  return apiFetch<StudentHomeData>("/api/app/aluno/inicio");
}
